import * as Diff from 'diff';
import './CodeComparison.scss';
import { CodeDiffCard } from './CodeDiffCard';
import React from 'react';
import { Col, Row } from 'antd';
export const CodeComparison = ({ newCode, oldCode }) => {
    const diff = Diff.diffWordsWithSpace(oldCode !== null && oldCode !== void 0 ? oldCode : '', newCode !== null && newCode !== void 0 ? newCode : '');
    return (React.createElement(Row, { className: 'code-comparison', gutter: 20, justify: 'space-between' },
        React.createElement(Col, { span: 12 },
            React.createElement(CodeDiffCard, { diff: diff, type: 'old' })),
        React.createElement(Col, { span: 12 },
            React.createElement(CodeDiffCard, { diff: diff, type: 'new' }))));
};
